export const SHIFT_STATUSES = {
    PENDING: 'pending',
    OPEN: 'open',
    CLOSING: 'closing',
    CLOSED: 'closed',
    ERROR: 'error'
}